// src/modules/manualJournal/routes.jsx

import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ManualJournalPage from './pages/ManualJournalPage';

export const manualJournalRoutes = [
  {
    path: '/manual-journal',
    element: <ManualJournalPage />,
    label: 'Manual Journal',
    icon: 'BookOutlined',
  },
];

export default function ManualJournalRoutes() {
  return (
    <Routes>
      <Route path="/" element={<ManualJournalPage />} />
    </Routes>
  );
}
